import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import HeroSlide from "./HeroSlide";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation"; 
import './HeroSlider.css'

export default function HeroSlider({ slides }) {
  return (
    <div className="hero-slider-container">
      <Swiper
        modules={[Navigation, Autoplay, Pagination]}
        pagination={{ clickable: true }}
        navigation={true} // Enable arrows
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        className="custom-swiper"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <HeroSlide slide={slide} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}